export const reloadValue = (state) => state.reload.value;
